export const __FLASH_VERSION__: number = 18.0;
let scripts: HTMLCollectionOf<HTMLScriptElement> = document.getElementsByTagName('script');
let last: HTMLScriptElement = scripts[scripts.length - 1];
let path: string[] = last.src.split('?')[0].split('/');

export const __PLANET_MEDIA_PLAYER_BASE_URL__: string = path.slice(0, path.length - 1).join('/');
export const __PLANET_MEDIA_PLAYER_VERSION__: string = '[AIV]{version}[/AIV]';

export const COOKIE_CLIENT_ID: string = 'planet_cid';
export const COOKIE_VISIT: string = 'planet_nid';
